// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"6":"483c4628","167":"0f967d91","198":"962c73d9","281":"95095668","357":"0f906092","412":"a9d94612","420":"e813e1fd","438":"d090232d","828":"bc54bcb3"}[chunkId] + ".chunk.css";
};